import React from "react";
import { Box, Chip, Tooltip, Typography } from "@mui/joy";
import FavoriteBorderRoundedIcon from "@mui/icons-material/FavoriteBorderRounded";
import { formatHeartbeatTriggerTime } from "../utils/heartbeatTime";

interface HeartbeatTriggerCardProps {
  createdAt: Date;
  taskId?: string;
}

export const HeartbeatTriggerCard: React.FC<HeartbeatTriggerCardProps> = ({
  createdAt,
  taskId,
}) => {
  const label = formatHeartbeatTriggerTime(createdAt);
  const tooltipText = taskId
    ? `This run was triggered by a heartbeat. Task ID: ${taskId}`
    : "This run was triggered by a heartbeat.";

  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 0.5 }}>
      <Tooltip title={tooltipText} arrow variant="outlined">
        <Chip
          variant="soft"
          color="neutral"
          startDecorator={<FavoriteBorderRoundedIcon sx={{ fontSize: 16 }} />}
          sx={{
            maxWidth: "100%",
            borderRadius: 999,
            bgcolor: "neutral.softBg",
            color: "neutral.700",
            border: "1px solid",
            borderColor: "neutral.outlinedBorder",
            px: 1.25,
            py: 0.5,
          }}
        >
          <Typography level="body-sm" sx={{ fontWeight: 500 }}>
            {label}
          </Typography>
        </Chip>
      </Tooltip>
    </Box>
  );
};

export default HeartbeatTriggerCard;
